import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { rootTranslation } from 'utils/format';
import { Trans } from 'react-i18next';
import { Text } from 'components/styleguide';
import { BackToSearchButton } from '../BackToSearchButton';

const rootT = 'drawers.productionSetup.tracks';
const t = rootTranslation(rootT);

export function CreateEmptyLibraryState() {
  return (
    <Box
      sx={{
            display: 'flex',
            flexDirection: 'column',
            py: 3,
            mx: 'auto',
            width: '730px',
            mt: 3,
            textAlign: 'center',
        }}
    >
      <Box>
        <Typography variant="h4">{t('createLibraryPlaceholder.heading')}</Typography>
      </Box>
      <Box sx={{
        textAlign: 'start',
      }}
      >
        <Box
          sx={{
            display: 'flex',
            mx: 'auto',
            mt: 3,
            }}
        >
          <Trans i18nKey={`${rootT}.createLibraryPlaceholder.step1`}>
            <Text variant="body1" bold />
            <Text variant="body1" />
          </Trans>
        </Box>
        <Box
          sx={{
            display: 'flex',
            mx: 'auto',
            }}
        >
          <Trans i18nKey={`${rootT}.createLibraryPlaceholder.step2`}>
            <Text variant="body1" bold />
            <Text variant="body1" />
          </Trans>
        </Box>
        <Box
          sx={{
            display: 'flex',
            mx: 'auto',
            mb: 3,
            }}
        >
          <Trans i18nKey={`${rootT}.createLibraryPlaceholder.step3`}>
            <Text variant="body1" bold />
            <Text variant="body1" />
          </Trans>
        </Box>
      </Box>
      <Box sx={{ mb: 3 }}>
        <Trans
          i18nKey={`${rootT}.createLibraryPlaceholder.bodySecondary`}
          components={[
            <Text variant="body1" component="span" />,
            <Text variant="body1" component="span" bold />,
            <Text variant="body1" component="span" />,
          ]}
        />
      </Box>
      <div>
        <BackToSearchButton variant="outlined" />
      </div>
    </Box>
  );
}
